import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { accessOptionsActionType } from '../actions/actionTypes';

export const REDUCER_NAME = 'AccessOptionsFilterList';

const logAccOptsListReq = (state, action) => ({
  ...state,
  listRequestedOn: new Date(),
  listRequest: action.data ? action.data : state.listRequest,
  loading: true,
});

const updateFilterConfig = (state, action) => {
  if (action.data.systemDefault) {
    return {
      ...state,
      systemDefaultFilter: action.data.systemDefault || null,
      userDefaultFilter: action.data.userDefault || null,
      selectedFilter: action.data.selectedItem || null,
    };
  }
  if (action.data.userDefault === null || action.data.userDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault,
    };
  }
  return {
    ...state,
    selectedFilter: action.data.selectedItem || null,
  };
};

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const updateTableConfig = (state, action) => ({
  ...state,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  selectedFilter: action.data ? action.data : null,
});

function AccessOptionsFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case accessOptionsActionType.UPDATE_ACCESSOPTS_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case accessOptionsActionType.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case accessOptionsActionType.REMOVE_ACCESSOPTS_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    default:
      return null;
  }
}

function AccessOptionsFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case accessOptionsActionType.LOG_ACCESSOPTS_LIST_REQUEST:
      return logAccOptsListReq(state, action);
    // log error
    case accessOptionsActionType.GET_ACCESSOPTS_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case accessOptionsActionType.GET_ACCESSOPTS_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case accessOptionsActionType.GET_ACCESSOPTS_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case accessOptionsActionType.RESET_ACCESSOPTS_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}
const AccessOptionsFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = AccessOptionsFilterListConfig(state, action);
  const stateReqRes = AccessOptionsFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default AccessOptionsFilterList;
